import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { Api } from "../../../../services/api";


export const ProtestInfo = ({ rowInfo, close }) => {
    const {
        usuario_nome,
        cobranca_id
    } = rowInfo;
    const [protestData, setProtestData] = useState([])
    const [showData, setShowData] = useState(false);

    useEffect(() => {
        const getProtestInfo = async () => {
            try {
                //o retorno dessa chamada de api é
                //um array contendo objetos
                const responseUser = await Api.get(`protesto/cobranca/info/${cobranca_id}`)
                const data = responseUser.data;
                // se houver info
                if (data.length > 0) {
                    let arrayCobrancas = []
                    //por cada objeto
                    data.forEach(e => {
                        if (e.protesto_status !== 'Sem Protesto') {
                            arrayCobrancas.push(e)
                        }
                        setProtestData(arrayCobrancas);
                    });
                }
                setShowData(true)
            } catch (error) {
                console.log(error.response)
            }
        }
        getProtestInfo()
    }, [])

    return (
        <Dialog
            visible
            header={`Informações de Protesto`}
            pt={{
                root: {
                    className: 'lg:min-w-[50%] lg:max-w-[60%] md:min-w-[66.66%] md:max-w-[77.77%] w-full text-center'
                }
            }}
            onHide={() => close()}
            draggable={true}
        >
            {//se for uma cobrança dentro de uma negociação ou se for a negociação em si protestada
                (showData && protestData.length > 0)
                    ? <div className="">
                        <DataTable
                            header={
                                <h5 className="text-lg"><b>Nome: </b>{usuario_nome}</h5>
                            }
                            value={protestData}
                            size={'small'}
                            tableStyle={{ minWidth: '50rem' }}
                        >
                            <Column field='cobranca_descricao' header='Descrição' />
                            <Column field='cartorio_nome' header='Cartório' />
                            <Column field='numero_protocolo' header='Numero Protocolo' />
                            <Column field='data_protocolo' header='Data de Protocolo' />
                            <Column field='protesto_status' header='Status atual' />
                            <Column field='data_envio' header='Data de envio' />
                        </DataTable>
                    </div>
                    : (showData && protestData.length === 0)
                        ? <div className="">
                            <h5> Sem protesto </h5>
                        </div>
                        : <ProgressSpinner strokeWidth="6" />
            }
        </Dialog>
    )
}